import {
    Box,
} from '@mui/material';
import LegendItem from './LegendItem';

function Legend(props) {
    return (
        <Box sx={{ display: 'flex', ...props.sx}}>
            {props.items.map(i => <LegendItem key={crypto.randomUUID()} label={i.label} color={i.color} />)}
        </Box>
    );
};

export default Legend
